import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DIALOG_BUTTONS } from '../../constants';

@Component({
  selector: 'app-image-dialog',
  templateUrl: './image-dialog.component.html',
  styleUrls: ['./image-dialog.component.scss'],
  standalone: false,
})
export class ImageDialogComponent {
  data = inject<{
    url: string;
    base64?: boolean;
  }>(MAT_DIALOG_DATA);
  translate = inject(TranslateService);

  readonly buttons = DIALOG_BUTTONS;

  constructor() {
    const translate = this.translate;

    translate.addLangs(['en']);
    translate.setDefaultLang('en');
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en/) ? browserLang : 'en');
  }
}
